/*global $ */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './no-context-menu.scss';

class NoContextMenu extends Component {
  static propTypes = {
    groups: PropTypes.array.isRequired,
    actionType: PropTypes.oneOf(['contextmenu', 'click', 'hover'])
  };
  static initialized = false;

  static initialize() {
    if (!NoContextMenu.initialized) {
      window.addEventListener('keyup', event => {
        if (event.key === 'Escape') {
          NoContextMenu.closeContextMenus();
        }
      });
      window.addEventListener('click', event => {
        for (var menu of NoContextMenu.menus) {
          if (menu.state.isOpen) {
            menu.setState({
              isOpen: false
            });
          }
        }
      });
      NoContextMenu.initialized = true;
    }
  }

  static menus = [];

  static closeContextMenus() {
    for (var menu of NoContextMenu.menus) {
      if (menu.state.isOpen) {
        menu.setState({
          isOpen: false
        });
      }
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      eventValues: {},
      openEvent: null
    };
    NoContextMenu.menus.push(this);
    NoContextMenu.initialize();
  }

  componentWillUnmount() {
    var index = NoContextMenu.menus.findIndex(menu => menu === this);

    if (index >= 0) {
      NoContextMenu.menus.splice(index, 1);
    }
  }

  handleRightClick(event) {
    var {
      alwaysCentered = false
    } = this.props;

    if (!event.shiftKey && !event.ctrlKey) {
      NoContextMenu.closeContextMenus();
      var left = null;
      var top = null;

      if (alwaysCentered) {
        var box = event.target.getBoundingClientRect();
        left = box.x + event.target.offsetWidth / 2;
        top = box.y + event.target.offsetHeight / 2;
      } else {
        left = event.clientX;
        top = event.clientY;
      } // 200 is min width, this needs to be the width of the context menu


      if (left + 200 > window.innerWidth) {
        left -= 200;
      }

      event.preventDefault();
      event.stopPropagation();
      this.setState({
        isOpen: true,
        eventValues: {
          left,
          top
        },
        openEvent: event
      });
    }
  }

  handleActionClick(event, action) {
    var {
      object
    } = this.props;
    var {
      openEvent
    } = this.state;
    var {
      disabled,
      onClick,
      subMenu
    } = action;

    if (!disabled && !subMenu && typeof onClick === 'function') {
      onClick(object, {
        actionEvent: event,
        openEvent
      });
      this.setState({
        isOpen: false,
        openEvent: null
      });
    }
  }

  render() {
    var {
      actionType = 'contextmenu',
      children,
      groups,
      object
    } = this.props;
    var {
      isOpen,
      eventValues,
      openEvent
    } = this.state;
    var propsToAdd = {
      onContextMenu: event => this.handleRightClick(event)
    };

    if (actionType === 'click') {
      propsToAdd = {
        onClick: event => this.handleRightClick(event)
      };
    }

    var child = /*#__PURE__*/React.cloneElement(React.Children.only(children), propsToAdd);
    var groupsToUse = groups;

    if (isOpen) {
      groupsToUse = groups.map(group => {
        var actions = group.filter(action => {
          var {
            shouldShow
          } = action;

          if (shouldShow === undefined) {
            shouldShow = true;
          }

          if (typeof shouldShow === 'function') {
            shouldShow = shouldShow(object, {
              openEvent
            });
          }

          return !!shouldShow;
        });
        return actions;
      }).filter(group => !!group.length);
    }

    return /*#__PURE__*/React.createElement(React.Fragment, null, child, isOpen && /*#__PURE__*/React.createElement("div", {
      className: "noContextMenu",
      style: {
        left: eventValues.left,
        top: eventValues.top
      }
    }, groupsToUse.map((group, i) => /*#__PURE__*/React.createElement(React.Fragment, {
      key: i
    }, i > 0 && /*#__PURE__*/React.createElement("div", {
      className: "noContextGroupSeperator"
    }), /*#__PURE__*/React.createElement(NoContextGroup, {
      group: group,
      handleActionClick: (event, action) => this.handleActionClick(event, action),
      object: object
    })))));
  }

}

class NoContextGroup extends Component {
  render() {
    var {
      group,
      handleActionClick,
      object
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: "noContextGroup"
    }, group.map(action => /*#__PURE__*/React.createElement(NoContextAction, {
      action: action,
      key: action.name,
      handleClick: event => handleActionClick(event, action),
      object: object
    })));
  }

}

class NoContextAction extends Component {
  state = {
    hovered: false
  };

  handleMouseEnter(event) {
    this.setState({
      hovered: true
    }); // close sibling submenus
  }

  handleMouseLeave(event) {
    this.setState({
      hovered: false
    });
  }

  render() {
    var {
      action: {
        name
      },
      handleClick,
      object
    } = this.props;
    var {
      hovered
    } = this.state;
    var actionClassName = classnames('noContextAction', {
      noContextHover: hovered
    });
    return /*#__PURE__*/React.createElement("div", {
      className: actionClassName,
      key: name,
      onClick: event => handleClick(event),
      onMouseEnter: event => this.handleMouseEnter(event),
      onMouseLeave: event => this.handleMouseLeave(event)
    }, name);
  }

}

export default NoContextMenu;